import { gql } from '@apollo/client';

const schema = {
  delete: {
    name: 'deleteRequest',
    serviceName: 'auth',
    query: gql`
      mutation deleteRequest($ids: [String]!) {
        deleteRequest(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
